import { createApiCall } from 'lib/base';

const POST_INVESTCORE_ORDER_EDIT_API_ID =
  'DASHBOARD/POST_INVESTCORE_ORDER_CREATE_API';

const apiCall = createApiCall(
  POST_INVESTCORE_ORDER_EDIT_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/orders`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
